<template>
  <div class="spinner" />
</template>

<script>
export default {
  name: 'SuggestionSpinner',
};
</script>

<style lang="scss">
.spinner {
  animation: spin 1s linear infinite;
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border-top-color: transparent;
  background: linear-gradient(0deg, var(--deEmphasisedText), var(--backgroundStrongest) 50%);

  &::after {
    @apply bg-background-strongest;
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: 50%;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
